export default __webpack_public_path__ + "static/media/BankTransfersVirtualAccountPmtPrev.33b9953d.jpeg";